import { createFileRoute } from "@tanstack/react-router";
import Wallet from "@/pages/Wallet";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/wallet")({
  head: () => ({
    meta: [
      { title: "Membership & Billing | Statlign" },
      { name: "description", content: "Your Statlign pass, coverage window and billing history." },
      { property: "og:title", content: "Membership & Billing | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Your Statlign pass, coverage window and billing history." },
      { name: "twitter:title", content: "Membership & Billing | Statlign" },
      { name: "twitter:description", content: "Your Statlign pass, coverage window and billing history." },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <MainLayout>
      <Wallet />
    </MainLayout>
  ),
});
